import { module } from 'modujs';
import { randomRange } from '../utils/maths';
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin.js";
import { gsap } from "gsap";

export function path(svg) {
    return /*html*/`
    <svg viewBox="0 0 100 10" aria-hidden="true" preserveAspectRatio="none" aria-hidden="true">
        <path  style="fill:none;stroke-width:2px;stroke-linecap:round;" d="M${svg.origin.x},${svg.origin.y}C${svg.origin.bezier.x},${svg.origin.bezier.y},${svg.target.bezier.x},${svg.target.bezier.y},${svg.target.x},${svg.target.y}"/>
    </svg>
    `
}

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        gsap.registerPlugin(DrawSVGPlugin);

        gsap.config({
            nullTargetWarn: false
        });

        //config
        this.delay = this.getData('delay') || 0;

        this.$lines = this.$('line');

        this.bindEvents();
        this.generateLines();
    }

    ////////////////////
    // Events
    ////////////////////
    bindEvents() {

    }

    ////////////////////
    // Methods
    ////////////////////
    generateLines() {
        this.$lines.forEach((element) => {
            element.classList.add('o-line');

            const svg = {};

            svg.origin = {
                x: 2,
                y: randomRange(2, 8),
                bezier: {
                    x: randomRange(15, 22),
                    y: randomRange(2, 10)
                }
            }
            svg.target = {
                x: 98,
                y: randomRange(2, 8),
                bezier: {
                    x: randomRange(38, 42),
                    y: randomRange(2, 10)
                }
            }

            //create SVG DOM element
            const dummy = document.createElement('div');
            dummy.innerHTML = path(svg);
            const svgHTML = dummy.children[0];

            //set path to 0
            gsap.set(svgHTML.querySelectorAll('path'), {
                drawSVG: 0
            });

            //append children
            element.appendChild(svgHTML);
        });
    }

    animatePath(event) {
        if (event.obj.el != this.el) {
            return;
        }

        gsap.to(this.el.querySelectorAll('path'), {
            duration: 1,
            drawSVG: "100%",
            delay: this.delay,
            ease: "power2.out",
            stagger: .4
        });
    }

    destroy() {
        super.destroy();
    }
}
